// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cpkeRodgFvq17u {
  position: relative;
  width: 768px;
  height: 512px;
  margin-right: auto;
  margin-left: auto;
  overflow: hidden;
  border-radius: 3px;
  background-attachment: scroll;
  background-color: var(--ds-surface, #ffffff);
  background-repeat: no-repeat;
  background-size: contain;
  background-position-x: right;
  background-position-y: top;
}
.cpkeRodgFvq17u > div {
  height: 100%;
}
.xqyxWfvGjBmjGG {
  position: absolute;
  z-index: 1;
  top: 0;
  right: 0;
}
.xqyxWfvGjBmjGG .s0kohsZ09T5KkG {
  margin: 6px;
}
.wbLsv3xwNHeMlk {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  margin-right: 50%;
  padding-left: 32px;
  overflow-y: auto;
}
.qFiXjMbaRGI_Kb {
  padding-bottom: 16px;
}
.eL1h2TOcrhrXdT {
  margin-top: 40px;
  color: var(--ds-text, #172b4d);
  font-size: 24px;
  letter-spacing: -0.01em;
  line-height: 28px;
  font-weight: var(--ds-font-weight-semibold, 600);
  margin: 0;
  overflow: hidden;
  font-weight: var(--ds-font-weight-medium, 500);
  text-overflow: ellipsis;
}
.Y3YxF0qT3Cc1j7 {
  flex-wrap: wrap;
  justify-content: center;
  margin: 20px 10px 40px;
  padding-left: 1em;
  list-style: disc;
}
.Y3YxF0qT3Cc1j7 li {
  margin: 16px 0;
}
.PEa16bTAVRPIQi {
  position: absolute;
  top: 0;
  right: 0;
  max-width: 50%;
}
.NGVRFCTA78JEsz {
  display: none;
}
@media only screen and (max-width: 750px) {
  .cpkeRodgFvq17u {
    width: 510px;
    max-width: 100vw;
    height: auto;
    min-height: 512px;
    padding: 0;
    /* stylelint-disable-next-line declaration-no-important */
    background-image: none !important;
  }
  .cpkeRodgFvq17u > div {
    /* stylelint-disable-next-line declaration-no-important */
    margin: 0 !important;
  }
  .wbLsv3xwNHeMlk {
    display: block;
    margin-right: 0;
    padding: 36px 24px;
  }
  .wbLsv3xwNHeMlk {
    margin-right: 0;
  }
  .MQXmUw6B5V_OnR {
    width: 100%;
    min-width: 375px;
  }
  .PEa16bTAVRPIQi {
    display: none;
  }
  .NGVRFCTA78JEsz {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 200px;
    overflow: hidden;
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dialog": `cpkeRodgFvq17u`,
	"controls": `xqyxWfvGjBmjGG`,
	"closeButton": `s0kohsZ09T5KkG`,
	"content": `wbLsv3xwNHeMlk`,
	"header": `qFiXjMbaRGI_Kb`,
	"title": `eL1h2TOcrhrXdT`,
	"managedAccountContent": `Y3YxF0qT3Cc1j7`,
	"illustrationFull": `PEa16bTAVRPIQi`,
	"illustrationMobile": `NGVRFCTA78JEsz`,
	"illustration": `MQXmUw6B5V_OnR`
};
export default ___CSS_LOADER_EXPORT___;
